/* global swal  angular*/
import './style.less';
import { find, orderBy, isEqual } from 'lodash';
import moment from 'moment-timezone';
import './style.less';

export default event => {
  return ($q, $scope, $state, ApiClass, $uibModalInstance, ProfileClass, $log, CategoryClass, EventClass, Swal) => {
    'ngInject';

    const companyInfo = ProfileClass.profileComplete.company;
    $scope.event = event;
    $scope.url = 'https://';

    const hasWebinarLocation = $scope.event.locations.map(({ location }) => location.toLowerCase()).includes('webinar');

    const requiredWebinarLocation = !hasWebinarLocation && EventClass.isGroupLive($scope.event);

    $scope.showAddWebinar =
      !requiredWebinarLocation &&
      (hasWebinarLocation ||
        $scope.event.type === 'other' ||
        $scope.event.type === 'external' ||
        $scope.event.externals.length);

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.enable = integration => {
      resetState();
      if (integration === 'acpen') {
        $scope.enableAcpenSelect();
        $scope.acpen = true;
      }
      if (integration === 'boosterLearn') $scope.boosterLearn = true;
      if (integration === 'zoom') $scope.zoom = true;
      if (integration === 'zoomMeeting') $scope.zoomMeeting = true;
      if (integration === 'goToWebinar') {
        $scope.enableGoToWebinarSelect();
        $scope.goToWebinar = true;
      }
      if (integration === 'cnf') {
        $scope.enablCnfSelect();
      }
      if (integration === 'webex') {
        $scope.enableWebexSelect();
        $scope.webex = true;
      }
      if (integration === 'other') {
        $scope.other = true;
      }
    };

    $scope.enableAcpenSelect = userId => {
      $scope.rawAcpen = false;
      $scope.acpenSelect = true;
      acpenInit('webinars', userId);
    };

    $scope.enableZoomSelect = userId => {
      $scope.rawZoom = false;
      $scope.zoomSelect = true;
      zoomInit('webinars', userId);
    };

    $scope.enableZoomMeetingSelect = userId => {
      $scope.rawZoom = false;
      $scope.zoomMeetingSelect = true;
      zoomInit('meetings', userId);
    };

    $scope.enableGoToWebinarSelect = () => {
      $scope.rawGoToWebinars = false;
      $scope.goToWebinarSelect = true;
      goToWebinarInit();
    };

    $scope.enablCnfSelect = () => {
      $scope.rawCnfs = false;
      $scope.cnfSelect = true;
      cnfInit();
    };

    $scope.enableWebexSelect = () => {
      $scope.rawWebexs = false;
      $scope.webexSelect = true;
      webexInit();
    };

    $scope.addAcpen = (acpenEvent, index) => {
      const { event_id: parentId, delivery_location_time_zone_id: timezone } = event;
      const { name: webinarName, startdatetime: startTime } = acpenEvent;
      addExternal(
        {
          parentId,
          webinarName,
          url: `https://api.ce21.com/service/Product/${acpenEvent.productid}`,
          startTime,
          timezone,
          ...acpenEvent,
          indexOrder: event.externals.length,
          type: 'acpenExternal'
        },
        index,
        $scope.rawAcpen
      );
    };

    $scope.addCnf = ({ name: webinarName, url, start_time: startTime, id }, index) => {
      const { event_id: parentId, delivery_location_time_zone_id: timezone } = event;
      addExternal(
        {
          parentId,
          webinarName,
          url,
          startTime,
          timezone,
          id,
          indexOrder: event.externals.length,
          type: 'cnfExternal'
        },
        index,
        $scope.rawCnfs
      );
    };

    $scope.addWebex = ({ sessionName: webinarName, startDate: startTime, sessionKey: webexSessionKey }, index) => {
      const { event_id: parentId, delivery_location_time_zone_id: timezone } = event;
      addExternal(
        {
          parentId,
          webinarName,
          startTime,
          timezone,
          webexSessionKey,
          indexOrder: event.externals.length,
          type: 'webexExternal'
        },
        index,
        $scope.rawWebexs
      );
    };

    $scope.selectZoom = (webinar, index) => {
      const id = event.event_id;

      addExternal(
        {
          parentId: id,
          indexOrder: event.externals.length,
          webinarName: webinar.topic,
          url: webinar.join_url,
          startTime: webinar.start_time,
          timezone: webinar.timezone,
          externalType: 'zoomWebinar',
          type: 'zoomExternal',
          zoomWebinarId: webinar.id.toString(),
          zoomUserId: $scope.zoomUserId
        },
        index,
        $scope.rawZoom
      );
    };

    $scope.selectZoomMeeting = (meeting, index) => {
      const id = event.event_id;

      addExternal(
        {
          parentId: id,
          indexOrder: event.externals.length,
          webinarName: meeting.topic,
          url: meeting.join_url,
          startTime: meeting.start_time,
          timezone: meeting.timezone,
          externalType: 'zoomMeeting',
          type: 'zoomExternal',
          zoomMeetingId: meeting.id.toString(),
          zoomUserId: $scope.zoomUserId
        },
        index,
        $scope.rawZoom
      );
    };

    $scope.addGoToWebinar = (webinar, index) => {
      const id = event.event_id;

      addExternal(
        {
          parentId: id,
          indexOrder: event.externals.length,
          webinarName: webinar.name,
          url: webinar.registrationUrl,
          startTime: webinar.times[0].startTime,
          timezone: webinar.timeZone,
          type: 'gtwEventExternal',
          webinarKey: webinar.webinarKey,
          webinarID: webinar.webinarId,
          organizerKey: webinar.organizerKey,
          accountKey: webinar.accountKey
        },
        index,
        $scope.rawGoToWebinars
      );
    };

    $scope.addOtherExternal = (webinarName, url) => {
      const { event_id: parentId, delivery_location_time_zone_id: timezone } = event;

      addExternal({
        parentId,
        indexOrder: event.externals.length,
        webinarName,
        url,
        timezone,
        type: 'otherExternal'
      });
    };

    $scope.addAcpenExternal = eventTimeId => {
      $scope.acpenError = false;
      const id = event.event_id;
      const acpenExternal = {
        parentId: id,
        eventTimeId,
        indexOrder: event.externals.length,
        externalType: 'acpenExternal'
      };
      $scope.programId = '';

      //  TODO: Migrate to eventExternal type route
      return ApiClass.eventsIdTypePut({ id, type: 'acpenExternal' }, acpenExternal, {
        queryParams: { manage: true }
      })
        .then(({ data: external }) => {
          $uibModalInstance.close(external);
        })
        .catch(error => {
          $scope.acpenError = true;
          $log.error(error);
          throw error;
        });
    };

    $scope.addBoosterLearnExternal = programId => {
      $scope.boosterLearnError = false;
      const id = event.event_id;
      const boosterLearnExternal = {
        parentId: id,
        programId,
        indexOrder: event.externals.length,
        externalType: 'boosterLearnExternal'
      };
      $scope.programId = '';

      //  TODO: Migrate to eventExternal type route
      return ApiClass.eventsIdTypePut({ id, type: 'boosterLearnExternal' }, boosterLearnExternal, {
        queryParams: { manage: true }
      })
        .then(({ data: external }) => {
          $uibModalInstance.close(external);
        })
        .catch(error => {
          $scope.boosterLearnError = true;
          $log.error(error);
          throw error;
        });
    };

    $scope.fieldStudyCheck = webinar => {
      return webinar.fields_of_study.some(({ name }) => {
        return !$scope.categoryNames.includes(name);
      });
    };

    $scope.fieldStudyEventCheck = webinar => {
      return isEqual(
        event.hours.map(({ subject_area }) => subject_area).sort(),
        webinar.fields_of_study.map(({ name }) => name).sort()
      );
    };

    function resetState() {
      $scope.cnfSelect = false;
      $scope.goToWebinarSelect = false;
      $scope.zoomSelect = false;
      $scope.zoomMeetingSelect = false;
      $scope.webexSelect = false;
      $scope.acpenError = false;
      $scope.acpen = false;
      $scope.boosterLearnError = false;
      $scope.boosterLearn = false;
      $scope.zoom = false;
      $scope.zoomMeeting = false;
      $scope.webex = false;
      $scope.other = false;
      $scope.rawWebexs = false;
      $scope.rawGoToWebinars = false;
      $scope.rawZoom = false;
      $scope.rawCnfs = false;
    }

    function addExternal(eventExternal, index, spliceArray) {
      if (index) spliceArray.splice(index, 1);

      const id = event.event_id;

      return ApiClass.eventsIdTypePut({ id, type: 'eventExternal' }, eventExternal, { queryParams: { manage: true } })
        .then(({ data: external }) => {
          $uibModalInstance.close(external);
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }

    function acpenInit() {
      ApiClass.eventsAssetsAcpenGet({}, {}, { queryParams: { manage: true, webexType: 'event' } })
        .then(({ data: { events } }) => {
          $scope.rawAcpen = orderBy(events, ['startdatetime'], ['asc']);
        })
        .catch(error => {
          $log.error(error);
          resetState();
          $scope.error = { status: 'Webinar Error', refresh: activate };
        });
    }

    function zoomInit(zoomType, userId) {
      $scope.zoomError = {};
      ApiClass.eventsAssetsZoomGet({}, {}, { queryParams: { manage: true, zoomType, userId } })
        .then(({ data: { events } }) => {
          if (!events.length) {
            $scope.zoomError = { status: 'No Content', text: `User has yet to schedule any Zoom ${zoomType}` };
            $scope.rawZoom = [];
            return;
          }
          const externalIds = event.externals.map(({ zoomWebinarId, zoomMeetingId }) => zoomWebinarId || zoomMeetingId);

          $scope.rawZoom = orderBy(
            events.filter(event => {
              event.sortTime = moment(event.start_time).valueOf();
              return !externalIds.includes(event.id.toString());
            }),
            ['sortTime'],
            ['asc']
          );
        })
        .catch(error => {
          $log.error(error);
          resetState();
          if (error.data.status == 424) {
            $scope.error = {
              status: 'Auth Error',
              refresh: activate,
              redirect: () => {
                $state.go('app.admin.settings.integrations');
                $scope.close();
              }
            };
          } else {
            $scope.error = { status: 'Webinar Error', refresh: activate };
          }
        });
    }

    function cnfInit() {
      ApiClass.eventsAssetsCnfGet({}, {}, { queryParams: { manage: true } })
        .then(({ data: { events } }) => {
          const cnfIds = event.externals.map(({ id }) => id);
          $scope.rawCnfs = orderBy(
            events.filter(event => {
              return !cnfIds.includes(event.id);
            }),
            ['sortTime'],
            ['asc']
          );
        })
        .catch(error => {
          $log.error(error);
          resetState();
          $scope.error = { status: 'Webinar Error', refresh: activate };
        });
    }

    function goToWebinarInit() {
      ApiClass.eventsAssetsGtwGet({}, {}, { queryParams: { manage: true } })
        .then(({ data: { events } }) => {
          $scope.rawGoToWebinars = events.reverse();
        })
        .catch(error => {
          $log.error(error);
          resetState();
          $scope.error = { status: 'Webinar Error', refresh: activate };
        });
    }

    function webexInit() {
      ApiClass.eventsAssetsWebexGet({}, {}, { queryParams: { manage: true, webexType: 'event' } })
        .then(({ data: { events } }) => {
          events.forEach(event => (event.sortTime = moment(event.startDate).valueOf()));
          $scope.rawWebexs = orderBy(events, ['sortTime'], ['asc']);
        })
        .catch(error => {
          $log.error(error);
          resetState();
          $scope.error = { status: 'Webinar Error', refresh: activate };
        });
    }

    function activate() {
      $scope.error = false;
      $q.all([
        ApiClass.companiesIdTypeGet({ manage: true, id: companyInfo.company_id, type: 'integrations' }, null, {}),
        CategoryClass.loadCategories()
      ])
        .then(([{ data: { items } }, { arr }]) => {
          $scope.categoryNames = arr.map(({ name }) => name);
          $scope.showZoom =
            find(items, {
              integration_id: 'zoom'
            }) && find(items, { integration_id: 'zoom' }).active;
          $scope.showGoToWebinar =
            find(items, {
              integration_id: 'go_to_webinar'
            }) && find(items, { integration_id: 'go_to_webinar' }).active;
          const hasAcpenExternal = $scope.event.externals.map(({ type }) => type).includes('acpenExternal');
          $scope.showAcpen =
            !hasAcpenExternal &&
            find(items, {
              integration_id: 'acpen'
            }) &&
            find(items, { integration_id: 'acpen' }).active;
          $scope.showBoosterLearn =
            find(items, {
              integration_id: 'boosterLearn'
            }) && find(items, { integration_id: 'boosterLearn' }).active;
          $scope.showCnf =
            find(items, {
              integration_id: 'cnf'
            }) && find(items, { integration_id: 'cnf' }).active;
          $scope.showWebex =
            find(items, { integration_id: 'webex' }) && find(items, { integration_id: 'webex' }).active;
          $scope.loaded = true;
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }

    activate();
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/addIntegration/index.js